import { BaseComponent } from "@symbiotejs/symbiote";
import { I18n } from "../../utilities/i18n/i18n";
import { MainNavbar } from "../../components/main-navbar/main-navbar.js";
import { FooterContainer } from "../../components/footer-container/footer-container.js";
import { HomeContainer } from "../../containers/home-container.js";
import { EventContainer } from "../../containers/event-container.js";




export class GridOrchestrator extends BaseComponent {

    // for the grid orchestrator to work, the router has been edited so that the barba-container get
    // the class 'row g-0' appended to it every time it changes because it is not feasible otherwise

    initCallback() {
        document.getElementsByTagName('grid-orchestrator')[0].classList.add('container')
        document.getElementsByTagName('grid-orchestrator')[0].classList.add('m-0')
        document.getElementsByTagName('grid-orchestrator')[0].classList.add('p-0')
    }

    static initiate() {
        document.body.insertAdjacentHTML('afterbegin', '<grid-orchestrator></grid-orchestrator>');
        // GridOrchestrator.attachEventListeners();
    }

    static attachEventListeners() {
        document.querySelectorAll('.side-advertisement').forEach(el => {
            el.addEventListener('click', function (evt) {
                if (evt.target.getAttribute('data-advert') === 'left')
                    window.open(desktopBannersRedirectionsPerLanguage[I18n.translateString('banners.desktopLeft')], 'leftFromMyEsports').focus()
                else
                    window.open(desktopBannersRedirectionsPerLanguage[I18n.translateString('banners.desktopRight')], 'rightFromMyEsports').focus()
            })
        })
    }





    static checkForFooterMagic(evt) {
        const footerIsVisible = document.getElementById('footerContainer').getBoundingClientRect().y < window.innerHeight
        const advertMarginFromTop = document.getElementById('outsideMenus').getBoundingClientRect().height - document.querySelector('.side-advertisement').getBoundingClientRect().height - document.getElementById('footerContainer').getBoundingClientRect().height - 10

        if (footerIsVisible) {
            document.querySelectorAll('.side-advertisement').forEach(el => {
                el.style.position = 'absolute'
                el.style.marginTop = `${advertMarginFromTop}px`
            })
        } else {
            document.querySelectorAll('.side-advertisement').forEach(el => {
                el.style.position = 'fixed'
                el.style.marginTop = ''
            })
        }
    }

    static getInitiatorPage = state => ({
        'home': '<home-container data-barba="container" data-barba-namespace="home-page" class="row g-0 g-0"></home-container>',
        'event': '<event-container data-barba="container" data-barba-namespace="events-page" class="row g-0 g-0"></event-container>',
        '404': '<notfound-page data-barba="container" data-barba-namespace="404" class="row g-0 g-0"></notfound-page>'
    }[state]);
}

GridOrchestrator.template = /*html*/ `
    <style>
      @media screen and (orientation: portrait) {
        grid-orchestrator .foo {
            <!-- foo -->    
        }
      }
      @media screen and (orientation: landscape) {
        grid-orchestrator .bar {
            <!-- foo -->    
        }
      }
    </style>


    <div id="outsideMenus" class="row g-0">
        <!-- Main Content -->
        <div id="contentColumn" class="col-10 offset-1">
            ${GridOrchestrator.getInitiatorPage(document.body.getAttribute('data-entry'))}
        </div>
        <!-- Footer -->
<!--        <div id="footerContainer" class="col-12 text-center">-->
<!--            <footer-container></footer-container>-->
<!--        </div>-->
    </div>
    
    <div id="menusWrapper" class="row g-0 fixed-top" style="z-index: 1056;">
        <main-navbar class="col-12"></main-navbar>
    </div>
`;

GridOrchestrator.reg('grid-orchestrator');
